import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=52497abb&scoped=true"
import script from "./ReservationList.vue?vue&type=script&lang=js"
export * from "./ReservationList.vue?vue&type=script&lang=js"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=52497abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52497abb",
  null
  
)

export default component.exports